import React, { Component } from 'react';
import { connect } from 'dva';
import { Layout } from 'antd';
import { Switch } from 'dva/router';
import { NavBarBase, LeftSideBar, TopBar } from '../basic';
import pathToRegexp from 'path-to-regexp';
import { enquireIsMobile } from '@/utils/enquireScreen';
import TabsLayout from './TabsLayout';
import './styles/basic.less';
import cx from 'classnames';
const { Content, Header } = Layout;
import { utils_tool, framework_tool } from '../../tool'
let { $$, Storage } = utils_tool
let { WizContainer } = framework_tool
/**
 * 基本部局
 * 可设置多种皮肤 theme: [light, grey, primary, info, warning, danger, alert, system, success, dark]
 * 可设置多种布局 [header(固定头), sidebar(固定边栏), breadcrumb(固定面包蟹), tabLayout(标签布局)]
 * @author weiq
 */
@connect(({ systemMenu }) => ({ systemMenu }))
export default class BaseHeadLayout extends WizContainer {
  constructor(props) {
    super(props);
    const user = $$.setStore('user', []);
    const theme = $$.setStore('theme', {
      layout: [
        'fixedHeader',//      固定头部
        'fixedSidebar',//      固定边栏
        'fixedBreadcrumbs',//      固定面包屑
        'hidedBreadcrumbs',//      隐藏面包屑
        'tabLayout',//      标签模式
      ],
      leftSide: 'light', // 左边
      navbar: 'light' // 顶部
    });

    this.state = {
      collapsedLeftSide: false, // 左边栏开关控制
      leftCollapsedWidth: 0, // 左边栏宽度
      expandTopBar: false, // 头部多功能区开合
      showSidebarHeader: false, // 左边栏头部开关
      collapsedRightSide: false, // 右边栏开关
      // theme, // 皮肤设置
      user,
      currentMenu: {},
      isMobile: false
    };
    this.user = Storage.getStorage('user')
  }

  componentDidMount() {
    this.unregisterEnquire = enquireIsMobile(ismobile => {
      const { isMobile } = this.state;
      if (isMobile !== ismobile) {
        this.setState({
          isMobile: ismobile
        });
      }
    });
  }
  componentWillUnmount() {
    // 清理监听
    this.unregisterEnquire();
  }

  render() {
    const {
      collapsedLeftSide,
      leftCollapsedWidth,
      expandTopBar,
      showSidebarHeader,
      collapsedRightSide,
      user,
      currentMenu,
      isMobile
    } = this.state;
    const { routerData, location, systemMenu } = this.props;
    const { menu, flatMenu } = systemMenu;
    const { childRoutes } = routerData;
    const classnames = cx('basic-layout', 'full-layout', 'base-head-layout');
    const theme = $$.getStore('theme')
    return (
      <Layout className={classnames}>
        <Header>
          <NavBarBase
            collapsed={collapsedLeftSide}
            // onCollapseLeftSide={this.onCollapseLeftSide}
            onExpandTopBar={this.onExpandTopBar}
            toggleSidebarHeader={this.toggleSidebarHeader}
            theme={theme.navbar}
            user={user}
            isMobile={isMobile}
          />
        </Header>
        <Layout>
          <Content>
            {/* {theme.layout.includes('tabLayout') ? (
              <TabsLayout childRoutes={childRoutes} location={location} />
            ) : (
              <Layout className="full-layout">
                <Content className="router-page">
                  <Switch>{childRoutes}</Switch>
                </Content>
              </Layout>
            )} */}
            <Layout className="full-layout">
                <Content className="router-page">
                  <Switch>{childRoutes}</Switch>
                </Content>
              </Layout>
          </Content>
        </Layout>
      </Layout>
    );
  }
}
